// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"665228db","151":"1325817f","510":"8923222b","761":"ddfd0940","832":"9c3b236a","949":"2ffadde1","980":"6922609e"}[chunkId] + ".chunk.js";
};